import React from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import {
    ShippingOrderContainer,
    ShippingOrderNo,
    SurgeryHeader,
    DetailsMainContainerBlock,
    MainContainerItems,
} from './ShippingDetails.styled';
import {
    Title,
    Subtitle,
} from 'src/pages/scheduleSurgery/components/surgery/SurgeryReviewAndSuccess.styled';
import { NOT_VISIBLE } from 'src/constants/appConstants';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const ShippingDetails = ({
    toggleCard,
    isShippingDetails,
    shipDetails,
    isEquity,
}) => {
    const { t } = useTranslation();
    let shippingDetails;
    if (isEquity) {
        shippingDetails = shipDetails;
    } else {
        shippingDetails = useSelector(
            (state) =>
                state.orderSummaryReducer?.orderBasicDetails?.shippingDetails
        );
    }

    const isConsignmentAdd = useSelector(
        (state) => state.orderSummaryReducer.orderBasicDetails?.currentOrderType
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );

    const poSurgeryVisibility = useSelector(
        (state) => state.loginReducer.poSurgeryVisibility
    );
    // const transferRecipient = useSelector(
    //     (state) =>
    //         state.orderSummaryReducer.orderBasicDetails?.transferRecipients?.[0]
    // );

    const transferRecipient = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.transferRecipients
    );

    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );

    const checkTransferRecipient = (recipients) => {
        if (!Array.isArray(recipients)) {
            return false;
        }

        return recipients.some((item) => {
            const transferRecipientAddress = item?.transferRecipientAddress;
            return (
                transferRecipientAddress &&
                typeof transferRecipientAddress === 'object' &&
                Object.keys(transferRecipientAddress).length > 0
            );
        });
    };
      
    
    const isTransferRecipients = checkTransferRecipient(transferRecipient);
    
    const careofAndTransferRecipient = (id) => {
        return transferRecipient?.find((item) => item?.sapOrderId == id);
    };

    return (
        <>
            <CollapsableCard
                id="orders-shippingDetails-shippingDetails-details"
                title={t('equity.submit.shippingDetails')}
                onClick={() =>
                    toggleCard('isShippingDetails', !isShippingDetails)
                }
                isExpanded={isShippingDetails}
                padding={'0.8rem'}
                cursor={'pointer'}
                overFlow={'hidden'}
                style={{
                    overflow: 'hidden',
                }}
                mbMarginBottom={isCondensedView && '2px'}
                mobileMargin={isCondensedView ? '10px 16px 2px 16px': ''}
            >
                {isShippingDetails ? (
                    <>
                        {shippingDetails ? (
                            <>
                                {shippingDetails?.map((shipping) => {
                                    return (
                                        <DetailsMainContainerBlock
                                            key={shipping?.sapOrderId}
                                        >
                                            {countryISOCode == 'US' && (
                                                <SurgeryHeader
                                                    lineHeight={'unset'}
                                                    headerHeight={'40px'}
                                                >
                                                    {shipping.salesOrg ===
                                                    'S002'
                                                        ? 'Non-Tissue'
                                                        : shipping.salesOrg ===
                                                              'S030' &&
                                                          (isEquity
                                                              ? t(
                                                                    'orders.orderTypes.tissueServices'
                                                                )
                                                              : t(
                                                                    'consignment.productType.type.tissue'
                                                                ))}
                                                    {/* {shipping?.salesOrg === 'Non-Tissue' ? `Non-Tissue` : 
                                                    shipping?.salesOrg ===
                                                    'Tissue' && `Tissue` } */}
                                                </SurgeryHeader>
                                            )}
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={
                                                        isTransferRecipients ||
                                                        isCondensedView
                                                            ? 4
                                                            : 6
                                                    }
                                                    md={
                                                        isTransferRecipients ||
                                                        isCondensedView
                                                            ? 4
                                                            : 6
                                                    }
                                                    lg={
                                                        isTransferRecipients ||
                                                        isCondensedView
                                                            ? 4
                                                            : 6
                                                    }
                                                    xl={
                                                        isTransferRecipients ||
                                                        isCondensedView
                                                            ? 4
                                                            : 6
                                                    }
                                                    mobile={12}
                                                >
                                                    {shipping?.sapOrderId ||
                                                    shipping?.shippingStatus ? (
                                                        <ShippingOrderContainer
                                                            paddingLeft={'7px'}
                                                            marginLeft={
                                                                isEquity
                                                                    ? '14px'
                                                                    : '0'
                                                            }
                                                        >
                                                            {shipping?.sapOrderId ? (
                                                                <ShippingOrderNo
                                                                    orderNumber
                                                                >
                                                                    {t(
                                                                        'orders.shipTrackLabels.sapOrderId'
                                                                    ) +
                                                                        ' ' +
                                                                        shipping?.sapOrderId}
                                                                </ShippingOrderNo>
                                                            ) : null}
                                                            {shipping?.shippingStatus ? (
                                                                <ShippingOrderNo
                                                                    orderStatus
                                                                >
                                                                    {
                                                                        shipping?.shippingStatus
                                                                    }
                                                                </ShippingOrderNo>
                                                            ) : null}
                                                        </ShippingOrderContainer>
                                                    ) : null}
                                                    {shipping?.shippingAddress ? (
                                                        <MainContainerItems
                                                            paddingLeft={'7px'}
                                                            setMarginBottom={
                                                                true
                                                            }
                                                            marginLeft={
                                                                isEquity
                                                                    ? '14px'
                                                                    : '0'
                                                            }
                                                            mbMarginBottom={"0px"}
                                                        >
                                                            <Title
                                                                showAstrisk={
                                                                    false
                                                                }
                                                            >
                                                                {t(
                                                                    'orders.orderDetails.replenRequest.shippingAddress'
                                                                )}
                                                            </Title>

                                                            {shipping?.attention ? (
                                                                <Subtitle>
                                                                    {'ATTN : '}{' '}
                                                                    {
                                                                        shipping.attention
                                                                    }
                                                                </Subtitle>
                                                            ) : null}
                                                            {shipping?.shipToAccount ? (
                                                                <Subtitle>
                                                                    {
                                                                        shipping?.shipToAccount
                                                                    }
                                                                </Subtitle>
                                                            ) : null}
                                                            {shipping
                                                                ?.shippingAddress
                                                                ?.line1 ? (
                                                                <Subtitle>
                                                                    {
                                                                        shipping
                                                                            ?.shippingAddress
                                                                            ?.line1
                                                                    }
                                                                </Subtitle>
                                                            ) : null}
                                                            {shipping
                                                                ?.shippingAddress
                                                                ?.city ||
                                                            shipping
                                                                ?.shippingAddress
                                                                ?.state ||
                                                            shipping
                                                                ?.shippingAddress
                                                                ?.postalCode ? (
                                                                <Subtitle>
                                                                    {
                                                                        shipping
                                                                            ?.shippingAddress
                                                                            ?.city
                                                                    }
                                                                    {','}{' '}
                                                                    {
                                                                        shipping
                                                                            ?.shippingAddress
                                                                            ?.state
                                                                    }{' '}
                                                                    {
                                                                        shipping
                                                                            ?.shippingAddress
                                                                            ?.postalCode
                                                                    }
                                                                </Subtitle>
                                                            ) : null}
                                                            {careofAndTransferRecipient(
                                                                shipping.sapOrderId
                                                            )?.careOfField ? (
                                                                <Subtitle>
                                                                    {`${t(
                                                                        'consignmentBilling.replen.selectShipToAddress.careOf'
                                                                    )} : `}{' '}
                                                                    {
                                                                        careofAndTransferRecipient(
                                                                            shipping.sapOrderId
                                                                        )
                                                                            ?.careOfField
                                                                    }
                                                                </Subtitle>
                                                            ) : null}
                                                        </MainContainerItems>
                                                    ) : null}
                                                </Grid>
                                                {careofAndTransferRecipient(
                                                                shipping ?.sapOrderId
                                                        )?.shipToAccount ? (
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={4}
                                                        md={4}
                                                        lg={4}
                                                        xl={4}
                                                        mobile={12}
                                                    >
                                                        <MainContainerItems
                                                            paddingLeft={'7px'}
                                                            setMarginBottom={
                                                                true
                                                            }
                                                            marginLeft={
                                                                isEquity
                                                                    ? '14px'
                                                                    : '0'
                                                            }
                                                            mbMarginBottom={"0px"}
                                                        >
                                                             {careofAndTransferRecipient(
                                                                shipping.sapOrderId
                                                            )?.shipToAccount ? (
                                                                <>
                                                                    <Title
                                                                        showAstrisk={
                                                                            false
                                                                        }
                                                                    >
                                                                        {t(
                                                                            'reportUsage.replen.selectShipToAddress.transferRecipient'
                                                                        )}
                                                                    </Title>
                                                                    {careofAndTransferRecipient(
                                                                        shipping.sapOrderId
                                                                    )
                                                                        ?.shipToAccount ? (
                                                                        <Subtitle>
                                                                            {
                                                                                careofAndTransferRecipient(
                                                                                    shipping.sapOrderId
                                                                                )
                                                                                    ?.shipToAccount
                                                                            }
                                                                        </Subtitle>
                                                                    ) : null}
                                                                    {careofAndTransferRecipient(
                                                                        shipping.sapOrderId
                                                                    )
                                                                        ?.transferRecipientAddress
                                                                        ?.line1 ? (
                                                                        <Subtitle>
                                                                            {
                                                                                careofAndTransferRecipient(
                                                                                    shipping.sapOrderId
                                                                                )
                                                                                    ?.transferRecipientAddress
                                                                                    ?.line1
                                                                            }
                                                                        </Subtitle>
                                                                    ) : null}
                                                                    {careofAndTransferRecipient(
                                                                        shipping.sapOrderId
                                                                    )
                                                                        ?.transferRecipientAddress
                                                                        ?.city ||
                                                                    careofAndTransferRecipient(
                                                                        shipping.sapOrderId
                                                                    )
                                                                        ?.transferRecipientAddress
                                                                        ?.state ||
                                                                    careofAndTransferRecipient(
                                                                        shipping.sapOrderId
                                                                    )
                                                                        ?.transferRecipientAddress
                                                                        ?.postalCode ? (
                                                                        <Subtitle>
                                                                            {
                                                                                careofAndTransferRecipient(
                                                                                    shipping.sapOrderId
                                                                                )
                                                                                    ?.transferRecipientAddress
                                                                                    ?.city
                                                                            }
                                                                            {
                                                                                ','
                                                                            }{' '}
                                                                            {
                                                                                careofAndTransferRecipient(
                                                                                    shipping.sapOrderId
                                                                                )
                                                                                    ?.transferRecipientAddress
                                                                                    ?.state
                                                                            }{' '}
                                                                            {
                                                                                careofAndTransferRecipient(
                                                                                    shipping.sapOrderId
                                                                                )
                                                                                    ?.transferRecipientAddress
                                                                                    ?.postalCode
                                                                            }
                                                                        </Subtitle>
                                                                    ) : null}{' '}
                                                                </>
                                                            ) : isCondensedView ? (
                                                                <>
                                                                    {shipping?.shippingAddress ? (
                                                                        <MainContainerItems
                                                                            paddingLeft={
                                                                                '7px'
                                                                            }
                                                                            setMarginBottom={
                                                                                true
                                                                            }
                                                                            marginLeft={
                                                                                isEquity
                                                                                    ? '14px'
                                                                                    : '0'
                                                                            }
                                                                        >
                                                                            <Title
                                                                                showAstrisk={
                                                                                    false
                                                                                }
                                                                            >
                                                                                {t(
                                                                                    'orders.orderDetails.replenRequest.shippingAddress'
                                                                                )}
                                                                            </Title>

                                                                            {shipping?.attention ? (
                                                                                <Subtitle>
                                                                                    {
                                                                                        'ATTN : '
                                                                                    }{' '}
                                                                                    {
                                                                                        shipping.attention
                                                                                    }
                                                                                </Subtitle>
                                                                            ) : null}
                                                                            {shipping?.shipToAccount ? (
                                                                                <Subtitle>
                                                                                    {
                                                                                        shipping?.shipToAccount
                                                                                    }
                                                                                </Subtitle>
                                                                            ) : null}
                                                                            {shipping
                                                                                ?.shippingAddress
                                                                                ?.line1 ? (
                                                                                <Subtitle>
                                                                                    {
                                                                                        shipping
                                                                                            ?.shippingAddress
                                                                                            ?.line1
                                                                                    }
                                                                                </Subtitle>
                                                                            ) : null}
                                                                            {shipping
                                                                                ?.shippingAddress
                                                                                ?.city ||
                                                                            shipping
                                                                                ?.shippingAddress
                                                                                ?.state ||
                                                                            shipping
                                                                                ?.shippingAddress
                                                                                ?.postalCode ? (
                                                                                <Subtitle>
                                                                                    {
                                                                                        shipping
                                                                                            ?.shippingAddress
                                                                                            ?.city
                                                                                    }
                                                                                    {
                                                                                        ','
                                                                                    }{' '}
                                                                                    {
                                                                                        shipping
                                                                                            ?.shippingAddress
                                                                                            ?.state
                                                                                    }{' '}
                                                                                    {
                                                                                        shipping
                                                                                            ?.shippingAddress
                                                                                            ?.postalCode
                                                                                    }
                                                                                </Subtitle>
                                                                            ) : null}
                                                                            {careofAndTransferRecipient(
                                                                                shipping.sapOrderId
                                                                            )
                                                                                ?.careOfField ? (
                                                                                <Subtitle>
                                                                                    {`${t(
                                                                                        'consignmentBilling.replen.selectShipToAddress.careOf'
                                                                                    )} : `}{' '}
                                                                                    {
                                                                                        careofAndTransferRecipient(
                                                                                            shipping.sapOrderId
                                                                                        )
                                                                                            ?.careOfField
                                                                                    }
                                                                                </Subtitle>
                                                                            ) : null}
                                                                        </MainContainerItems>
                                                                    ) : null}
                                                                </>
                                                            ) : null}
                                                        </MainContainerItems>
                                                    </Grid>
                                                ) : null}
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={4}
                                                    md={4}
                                                    lg={4}
                                                    xl={4}
                                                    mobile={12}
                                                >
                                                    {poSurgeryVisibility !==
                                                        NOT_VISIBLE &&
                                                    isConsignmentAdd !== 'KB' &&
                                                    shipping?.poNumber ? (
                                                        <ShippingOrderContainer
                                                            paddingLeft={'7px'}
                                                        >
                                                            <Title
                                                                showAstrisk={
                                                                    false
                                                                }
                                                                marginBottom={
                                                                    '0px'
                                                                }
                                                            >
                                                                {t(
                                                                    'scheduleSurgery.Shipping.ShippingCardItems.poNumber'
                                                                )}
                                                            </Title>
                                                            <Subtitle>
                                                                {
                                                                    shipping?.poNumber
                                                                }
                                                            </Subtitle>
                                                        </ShippingOrderContainer>
                                                    ) : null}
                                                    {shipping?.methodName ? (
                                                        <MainContainerItems
                                                            paddingLeft={'7px'}
                                                            setMarginBottom={
                                                                true
                                                            }
                                                        >
                                                            <Title
                                                                showAstrisk={
                                                                    false
                                                                }
                                                            >
                                                                {t(
                                                                    'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.shippingMethod'
                                                                )}
                                                            </Title>
                                                            <Subtitle>
                                                                {
                                                                    shipping?.methodName
                                                                }
                                                            </Subtitle>
                                                        </MainContainerItems>
                                                    ) : null}
                                                </Grid>
                                            </Grid>
                                        </DetailsMainContainerBlock>
                                    );
                                })}
                            </>
                        ) : null}
                    </>
                ) : null}
            </CollapsableCard>
        </>
    );
};

export default ShippingDetails;
